import { Col, DatePicker, Form, Input, Row, Select, Space, Table } from 'antd';
import {
  EyeIcon,
  FilterGoldIcon,
  FilterIcon,
  OrderHistory,
  OrderList,
} from 'assets/svg';
import { MainLayout } from 'components';
import { useFormik } from 'formik';
import { Content } from 'antd/es/layout/layout';
import Button from 'components/Button';
import { useEffect, useState } from 'react';
import pageTitleStore from 'store/pageTitleStore';
import formatDateMDY from 'utils/formatDateMDY';
import { ColumnsType } from 'antd/es/table';
import { HocChangePagination } from 'utils/HocChangePagination';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import useQueryParam from 'hooks/useQueryPrams';
import { CarOutlined } from '@ant-design/icons';
import { useQuery } from 'react-query';
import CartApi from 'apis/CartApi';

type FixedType = 'left' | 'right' | boolean;

export default function ChtCartList() {
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  useEffect(() => {
    setTitle('Giỏ hàng cửa hàng');
    setBreadcrumb([{ title: <a href="/order">Giỏ hàng cửa hàng</a> }]);
  }, []);
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const pagination = { page: page, page_size: page_size };
  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      cart_code: '',
      cart_name: '',
      cart_type: '',
      branch: '',
      brand: '',
      type: '',
      cart_status: '',
      register_status: '',
      release_date: [],
    },
    onSubmit(values) {
      const newValues = {
        ...values,
        start_date: formatDateMDY(values?.release_date[0]),
        end_date: formatDateMDY(values?.release_date[1]),
      };
      console.log(newValues);
    },
  });
  const { data: cart } = useQuery([], () => {
    return CartApi.getCartCHT(pagination)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  });
  const handleChangeSelect = (name: string) => {
    return (value: any) => {
      formik.setFieldValue(name, value);
    };
  };
  const handleChangeInput = (name: string) => {
    return (e: any) => {
      formik.setFieldValue(name, e.target.value);
    };
  };
  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 60,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã giỏ hàng',
      width: 160,
      render(value, record, index) {
        return <span>dsadsa</span>;
      },
    },
    {
      title: 'Loại giỏ hàng',
      width: 200,
    },
    {
      title: 'Tên giỏ hàng',
      width: 400,
    },
    {
      title: 'Nhãn hàng',
      width: 120,
    },
    {
      title: 'Người khai báo',
      width: 180,
    },
    {
      title: 'Phòng ban',
      width: 110,
    },
    {
      title: 'Đơn vị phát hành',
      width: 220,
    },
    {
      title: 'Công ty phát hành',
      width: 160,
    },
    {
      title: 'Đặt hàng theo ni',
      width: 150,
    },
    {
      title: 'Trạng thái',
      width: 150,
    },
    {
      title: 'Ngày bắt đầu',
      width: 150,
    },
    {
      title: 'Ngày hết hạn',
      width: 150,
    },
    {
      title: 'Cập nhật lần cuối',
      width: 150,
    },
    {
      title: 'Thao tác',
      fixed: 'right' as FixedType,
      width: 150,
      align: 'center',
      render: (_: any, record: any) => {
        <div className="flex justify-around">
          <button>
            <EyeIcon />
          </button>
          <button>
            <CarOutlined />
          </button>
          <button>
            <OrderList />
          </button>
        </div>;
      },
    },
  ];

  const { RangePicker } = DatePicker;
  return (
    <MainLayout>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
        <Col>
          <Space>
            <Button
              bgColor="bg-white"
              color="text-primary-50"
              border="border-primary-50"
            >
              <OrderHistory />
              Lịch sử đặt hàng
            </Button>
            <Button
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
          </Space>
        </Col>
      </Row>

      <Form
        layout="vertical"
        className={`items-center ${isOpenFilter ? '' : 'hidden'} mt-4`}
        autoComplete="off"
        onSubmitCapture={formik.handleSubmit}
      >
        <Content>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={8}>
              <Form.Item name="cart_code" label="Mã giỏ hàng">
                <Input
                  onChange={handleChangeInput('cart_code')}
                  placeholder="Nhập mã giỏ hàng"
                  className=""
                />
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item name="cart_name" label="Tên giỏ hàng">
                <Input
                  onChange={handleChangeInput('cart_name')}
                  placeholder="Nhập tên giỏ hàng"
                  className=""
                />
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item name="cart_type" label="Loại giỏ hàng">
                <Select
                  onChange={handleChangeSelect('cart_type')}
                  defaultValue={'Tất cả'}
                  size="middle"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={8}>
              <Form.Item name="branch" label="Ngành hàng">
                <Select
                  onChange={handleChangeSelect('branch')}
                  defaultValue={'Tất cả'}
                  size="middle"
                />
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item name="brand" label="Nhãn hàng">
                <Select
                  onChange={handleChangeSelect('brand')}
                  defaultValue={'Tất cả'}
                  size="middle"
                />
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item name="type" label="Chủng loại">
                <Select
                  onChange={handleChangeSelect('type')}
                  defaultValue={'Tất cả'}
                  size="middle"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={8}>
              <Form.Item name="cart_status" label="Trạng thái giỏ hàng">
                <Select
                  onChange={handleChangeSelect('cart_status')}
                  defaultValue={'Tất cả'}
                  size="middle"
                  //   options={[]}
                />
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item name="register_status" label="Trạng thái đăng ký">
                <Select
                  onChange={handleChangeSelect('register_status')}
                  defaultValue={'Tất cả'}
                  size="middle"
                />
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item name="release_date" label="Ngày phát hành">
                <RangePicker onChange={handleChangeSelect('release_date')} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={toggleFilter}
                >
                  Hủy
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>

      <Content className="mt-4 main-content">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          className="customTable"
          //   dataSource={lstCartData?.data}
          scroll={{ x: 958 }}
          //   loading={getCartsLoading}
          pagination={{
            className: 'flex items-center',
            // current: page,
            // pageSize: page_size,
            // total: lstCartData?.total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Content>
    </MainLayout>
  );
}
